export const MAX_BRANDS_HISTORY = 5;
